import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "dropdown-menu",
  role: "menu"
}
const _hoisted_3 = { class: "dropdown-content" }

import type { PropType } from 'vue'
import { ref } from 'vue'
import useDropdown from '../../../composable/useDropdown'
import VIcon from '../../base/icon/VIcon.vue'
type DropdownColor =
  | undefined
  | 'primary'
  | 'info'
  | 'success'
  | 'warning'
  | 'danger'


export default /*@__PURE__*/_defineComponent({
  __name: 'VDropdown',
  props: {
  title: {
    type: String,
    default: undefined,
  },
  color: {
    type: String as PropType<DropdownColor>,
    default: undefined,
    validator: (value: DropdownColor) => {
      // The value must match one of these strings
      if (
        [undefined, 'primary', 'info', 'success', 'warning', 'danger'].indexOf(
          value
        ) === -1
      ) {
        console.warn(
          `VDropdown: invalid "${value}" color. Should be primary, info, success, warning, danger or undefined`
        )
        return false
      }

      return true
    },
  },
  icon: {
    type: String,
    default: undefined,
  },
  up: {
    type: Boolean,
    default: false,
  },
  right: {
    type: Boolean,
    default: false,
  },
  modern: {
    type: Boolean,
    default: false,
  },
  spaced: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose: __expose }) {

const props = __props

const dropdownElement = ref<HTMLElement | null>(null)
const dropdown = useDropdown(dropdownElement)

__expose({
  ...dropdown,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dropdownElement",
    ref: dropdownElement,
    class: _normalizeClass([[
      props.right && 'is-right',
      props.up && 'is-up',
      props.icon && 'is-dots',
      props.modern && 'is-modern',
      props.spaced && 'is-spaced',
    ], "dropdown"])
  }, [
    _renderSlot(_ctx.$slots, "button", _normalizeProps(_guardReactiveProps(_unref(dropdown))), () => [
      (props.icon)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "is-trigger dropdown-trigger",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(dropdown).toggle && _unref(dropdown).toggle(...args)))
          }, [
            _createVNode(VIcon, {
              icon: props.icon
            }, null, 8, ["icon"])
          ]))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: _normalizeClass(["is-trigger button dropdown-trigger", [props.color && `is-${props.color}`]]),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(dropdown).toggle && _unref(dropdown).toggle(...args)))
          }, [
            (props.title)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(props.title), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass([!props.modern && 'base-caret', props.modern && 'base-caret'])
            }, [
              (!_unref(dropdown).isOpen)
                ? (_openBlock(), _createBlock(VIcon, {
                    key: 0,
                    icon: "fa:angle-down"
                  }))
                : (_openBlock(), _createBlock(VIcon, {
                    key: 1,
                    icon: "fa:angle-up"
                  }))
            ], 2)
          ], 2))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "content", _normalizeProps(_guardReactiveProps(_unref(dropdown))))
      ])
    ])
  ], 2))
}
}

})